import { createAction } from '@ngrx/store';
import { withGenesysCloudStoreNameSpace } from '../../common/action-namespace';

const withNameSpace = withGenesysCloudStoreNameSpace('RoutingStatus');

export const initializeModule = createAction(
  withNameSpace('Initialize module')
);

export const userNotResponding = createAction(
  withNameSpace('User not responding')
);

export const makeEligibleForInteractions = createAction(
  withNameSpace('Make eligible for interactions')
);
